import {
  CadmusEditorContent,
  useCadmusEditor,
} from "@vericus/cadmus-editor-prosemirror";
import { Text } from "@vericus/cadmus-ui";

import { useDeletedAnswerBlockQuery } from "@/generated/graphql";
import { parseBlockSnapshot } from "@/stores/snapshot";

import * as styles from "./answer-form.css";

interface Props {
  answerBlockId: string;
}

export function RecoveredExtendedResponseBody(props: Props) {
  const { answerBlockId } = props;

  const { data } = useDeletedAnswerBlockQuery({ variables: { answerBlockId } });
  const snapshotContent = data?.deletedAnswerBlock?.latestBlockSnapshot ?? null;

  let snapshot = null;
  if (snapshotContent) {
    try {
      snapshot = parseBlockSnapshot(snapshotContent);
    } catch {
      snapshot = null;
    }
  }
  const doc = snapshot?.answerDoc ?? null;

  const editor = useCadmusEditor(
    {
      editorId: `${answerBlockId}-recovery-readonly`,
      content: doc,
      editable: false,
      // Read-only surface, no paste risk: always render saved font marks.
      enableFontControls: true,
    },
    [snapshotContent, answerBlockId]
  );

  if (!doc) {
    return null;
  }

  return (
    <>
      <Text
        kind="systemMd"
        color="red500"
        style={{
          maxWidth: 710,
          paddingLeft: 45,
          paddingRight: 45,
          paddingTop: 12,
          paddingBottom: 24,
        }}
        inline
      >
        If you are seeing this, your answer to this question was temporarily
        hidden. This is the content for you to paste into the answer below.
      </Text>
      <div className={styles.editorResponseRecovered}>
        <Text
          kind="headingSix"
          style={{ paddingLeft: 45, paddingRight: 45 }}
          inline
        >
          Your hidden answer. Please use it to complete your answer below.
        </Text>
        <CadmusEditorContent
          pageMode={false}
          className={styles.editorResponseEditor}
          editor={editor}
        />
      </div>
      <Text
        kind="bodySm"
        style={{
          maxWidth: 710,
          paddingLeft: 45,
          paddingRight: 45,
          paddingTop: 12,
          paddingBottom: 24,
        }}
        inline
      >
        If you are seeing this message, your answer was temporarily hidden and
        may not have been saved. Please copy and paste the content above into
        the editor below. Only what you enter in the editor below will be saved.
        <br />
        <br />
        <strong>Your answer starts below.</strong>
      </Text>
    </>
  );
}
